import { onlyNumber } from '@shared/helpers/onlyNumber';
import React, { useState, useEffect } from 'react';

import SectionGrid from '@shared/components/SectionGrid';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import Cards from 'react-credit-cards-2';
import 'react-credit-cards-2/dist/es/styles-compiled.css';

import StyledTextField from '@shared/components/StyledTextField';
import { Box } from '@mui/material';

const signupSchema = Yup.object().shape({
  number: Yup.string()
    .required('Campo requerido')
    .matches('^[0-9]+$', 'Este campo solo admite numeros')
    .min(15, 'El numero de la tarjeta debe ser igual o mayor a 15 caracteres'),

  name: Yup.string()
    .required('Campo requerido')
    .matches(/^[aA-zZ" "]+$/, 'Este campo solo admite letras'),

  expiry: Yup.string().required('Campo requerido'),

  cvc: Yup.string()
    .required('Campo requerido')
    .matches('^[0-9]+$', 'Este campo solo admite numeros'),

  dni: Yup.string()
    .required('Campo requerido')
    .matches('^[0-9]+$', 'Este campo solo admite numeros'),
});

export const PaymentForm = ({ paymentValues, formikRef }) => {
  const [focus, setFocus] = useState('');

  const formik = useFormik({
    initialValues: {
      number: '',
      name: '',
      expiry: '',
      cvc: '',
      dni: '',
    },
    validationSchema: signupSchema,
    onSubmit: values => {
      const { expiry, ...cardInfo } = values;

      const splitExpiryDate = expiry.split('/');

      paymentValues({
        ...cardInfo,
        card_exp_month: splitExpiryDate[0],
        card_exp_year: splitExpiryDate[1],
      });
    },
  });

  useEffect(() => {
    if (formikRef) {
      formikRef.current = formik;
    }
  }, []);

  const handleInputFocus = e => {
    setFocus(e.target.name);
  };

  useEffect(() => {
    let val = onlyNumber(formik.values.expiry).slice(0, 4);

    if (val.length > 0 && val[0] !== '0' && val[0] !== '1') {
      val = '';
    }

    if (val.length > 1 && val[0] === '1' && !['0', '1', '2'].includes(val[1])) {
      val = val[0];
    }

    if (val.startsWith('00')) {
      val = val[0];
    }

    const valShow =
      val.length <= 2 ? val : `${val.slice(0, 2)}/${val.slice(2)}`;

    if (formik.values.expiry !== valShow) {
      formik.setFieldValue('expiry', valShow);
    }
  }, [formik.values.expiry]);

  return (
    <Box data-testid="paymentForm_container">
      <SectionGrid
        gridSx={{ paddingBottom: 0 }}
        customLayout={{
          xs: { 1: 12, 2: 12 },
          lg: { 1: 3, 2: 9 },
        }}
        customItemSx={{ 1: { paddingTop: '0px !important' } }}
      >
        <Box
          sx={{
            transform: {
              xs: 'scale(0.8)',
              lg: 'scale(0.6)',
              xl: 'scale(0.8)',
            },
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Cards
            cvc={formik.values.cvc}
            expiry={formik.values.expiry}
            focused={focus}
            name={formik.values.name}
            number={formik.values.number}
            placeholders={{ name: 'NOMBRE Y APELLIDO' }}
          />
        </Box>

        <SectionGrid
          gridSx={{ paddingBottom: 0, padding: { xs: '0' } }}
          customLayout={{
            xs: { 1: 12, 2: 6, 3: 6, 4: 12, 5: 12 },
            sm: { 1: 6, 2: 3.6, 3: 2.4, 4: 12, 5: 12 },
            md: { 1: 6, 2: 3, 3: 3, 4: 6, 5: 6 },
          }}
        >
          <StyledTextField
            name="number"
            label="Número de Tarjeta"
            formik={formik}
          />

          <StyledTextField
            name="expiry"
            label="Vencimiento"
            formik={formik}
            onFocus={handleInputFocus}
            inputProps={{ maxLength: 5 }}
          />

          <StyledTextField
            name="cvc"
            label="C V V"
            formik={formik}
            onFocus={handleInputFocus}
          />

          <StyledTextField
            name="name"
            label="Nombre y Apellido"
            formik={formik}
            onFocus={handleInputFocus}
          />

          <StyledTextField
            name="dni"
            label="Número de documento"
            formik={formik}
            onFocus={handleInputFocus}
          />
        </SectionGrid>
      </SectionGrid>
    </Box>
  );
};
